/* import __COLOCATED_TEMPLATE__ from './localization-editor.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class LocalizationEditor extends Component {
  @action
  reorderParts(localizedBotIntro, parts) {
    localizedBotIntro.set('parts', parts);
  }

  @action
  removePart(part) {
    this.args.localizedBotIntro.parts.removeObject(part);
  }

  @action
  addPart() {
    this.args.localizedBotIntro.parts.createFragment();
  }
}
